<template>
  <div>
    <router-view v-show='this.$route.matched.length===3'></router-view>
    <PageHeaderLayout v-show='this.$route.matched.length===2'>
      <div class='main-page-content'>
        <div>
          <div class='theme-border p-10'>
            <div class='flex-sb' style='gap: 10px'>

              <div>
                <template v-for='(option) in options'>
                  <el-button style='margin: 5px' @click='handleCreateOrUpdateTemplate(option.tpl)' type='primary' :key='option.tpl'>
                    创建/修改 【{{ option.label }}】
                  </el-button>
                </template>
                <el-tooltip
                  content='OA审批流程使用之前需要初始化模板，相当于钉钉的OA审批流程设置中的①基础设置、②表单设计操作。'
                  placement='top'>
                  <el-button type='text'><i class='el-icon-info'></i></el-button>
                </el-tooltip>
              </div>
              <!--              <div>-->
              <!--                <el-button @click='kolApprove' type='primary'>创建/修改推广投放付款申请</el-button>-->
              <!--                <el-button @click='normarlReimbursement' type='primary'>创建/修改通用报销申请</el-button>-->
              <!--                <el-button @click='Payment' type='primary'>创建/修改通用付款申请</el-button>-->
              <!--                <el-button @click='kolExpense' type='primary'>创建/修改红人费用报销申请</el-button>-->
              <!--                <el-button @click='pettyCash' type='primary'>创建/修改备用金申请</el-button>-->
              <!--                <el-button @click='saveTravel' type='primary'>创建/修改差旅报销申请</el-button>-->
              <!--              </div>-->
              <div>
                <el-link type='primary' icon='el-icon-arrow-left' @click='handleBack'>返回</el-link>
              </div>
            </div>


          </div>
          <div class='mb8'>
            <el-link type='primary' @click='getList' class='el-icon-refresh' style='cursor: pointer;margin: 10px 10px'>
              刷新
            </el-link>
          </div>
          <div class='default-table'>
            <el-table
              :border='true'
              :data='tableData'
              ref='multipleTable'
              row-key='id'
              style='width: 100%'
              tooltip-effect='dark'
              v-if="userPermissions.indexOf('oa_tpl_list') !== -1"
            >
              <el-table-column
                align='center'
                label='ID'
                prop='id'
                width='80'
              ></el-table-column>
              <el-table-column
                align='center'
                label='模板名称'
                prop='name'
                width='200'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='描述'
                prop='description'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='编号'
                min-width='180'
                prop='process_code'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='创建时间'
                prop='created_at'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='更新时间'
                prop='updated_at'
              >
              </el-table-column>
            </el-table>
          </div>
          <br />
          <div class='mb8 theme-border p-10'>
            <el-form :inline='true' label-position='right' v-model='searchStatus'>
              <el-form-item>
                <el-date-picker
                  @change='handlerQuery'
                  v-model='pickerTime'
                  type='month'
                  value-format='yyyy-MM'
                  placeholder='选择月'>
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type='primary' icon='el-icon-refresh'>刷新</el-button>
              </el-form-item>
            </el-form>
            <div class='theme-border'>
              <Chart :dataList='dataList' v-if='dataList &&dataList.length>0'></Chart>
            </div>
          </div>
          <br />
        </div>
      </div>

    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { mapGetters } from 'vuex'
import Chart from './chart.vue'

export default {
  name: 'OaTplManageTable',
  components: { PageHeaderLayout, Chart },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])

  },
  data() {
    return {
      // 数组data
      tableData: [],

      dataList: [],
      //筛选data
      searchStatus: {
        code: ''
      },
      optionsValue: '',
      options: [
        { value: 1, label: '推广投放付款申请', tpl: 'payment_template' },
        { value: 2, label: '红人费用报销申请', tpl: 'expense_template' },
        { value: 3, label: '通用付款申请', tpl: 'normal_payment_template' },
        { value: 4, label: '通用报销申请', tpl: 'normal_reimbursement_template' },
        { value: 5, label: '备用金申请', tpl: 'petty_cash_template' },
        { value: 6, label: '差旅报销申请', tpl: 'travel_template' },
        { value: 7, label: '红人分成付款申请', tpl: 'divide_template' }
      ],
      pickerTime: ''

    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /**
     * 创建、修改各种模板
     * @param template
     * @returns {Promise<void>}
     */
    async handleCreateOrUpdateTemplate(template) {
      const id = await this.$api.createOATemplate(template)
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()
      } else this.$notify.error('操作失败')
    },
    async Payment() {

      const id = await this.$api.normarlPayment()
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()
      } else this.$notify.error('操作失败')
    },
    async normarlReimbursement(value, code) {
      let id = ''
      if (value === 'update') {
        id = await this.$api.normarlReimbursement({
          'process_code': code
        })
      } else {
        id = await this.$api.normarlReimbursement()
      }
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()

      } else this.$notify.error('操作失败')
    }
    ,
    async pettyCash() {

      const id = await this.$api.pettyCash()
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()

      } else this.$notify.error('操作失败')
    }
    ,
    async kolApprove() {

      const id = await this.$api.kolApprove()
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()

      } else this.$notify.error('操作失败')
    }
    ,

    async kolExpense() {

      const id = await this.$api.kolExpense()
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()

      } else this.$notify.error('操作失败')
    },
    async saveTravel() {

      const id = await this.$api.saveTravel()
      if (id) {
        this.$notify.success('操作成功')
        await this.getList()

      } else this.$notify.error('操作失败')
    },
    handlerQuery() {
      this.getList()
    },
    searchCondition() {
      const searchCondition = {}
      if ((this.pickerTime || undefined) !== undefined) {
        searchCondition['year'] = Number(this.pickerTime.slice(0, 4))
        searchCondition['month'] = Number(this.pickerTime.slice(5, this.pickerTime.length))
      }
      return searchCondition
    },
    async getList() {
      const searchCondition = this.searchCondition()
      const { list } = await this.$api.oaTemplateList()
      const data = await this.$api.countTemplateList(searchCondition)
      this.tableData = list
      this.dataList = data
    },
    handleBack() {
      if(this.$route.state){
        // console.log(this.$route.state)
      }
      // this.$router.go(-1)
    }
  }
}
</script>
<style lang='scss'>
#foo > .el-checkbox__input.is-checked .el-checkbox__inner, .foo > * > .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border: 1px solid #409EFF;

}

#foo > * > .el-checkbox__inner:hover, .foo > * > * > .el-checkbox__inner:hover {
  border-color: #409EFF !important;
}

.foo > * > span:last-child {
  display: none;
}
</style>
